import React from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';

import { Authenticated, CanAccess, ErrorComponent } from '@refinedev/core';
// auth routes
import { CatchAllNavigate, NavigateToResource } from '@refinedev/react-router-v6';

import MainLayout from '@/components/layout/main-layout';
import AccountActivation from '@/pages/auth/account-activation';
import { ForgotPassword } from '@/pages/auth/forgot-password';
import Login from '@/pages/auth/login';
import { ResetPassword } from '@/pages/auth/reset-password';
import Branch from '@/pages/branch';
import BranchCreate from '@/pages/branch/create';
import BranchDetail from '@/pages/branch/show';
import BranchUpdate from '@/pages/branch/update';
import { CheckShippingPrice } from '@/pages/check-shipping-price';
import Contact from '@/pages/contact';
import ContactCreate from '@/pages/contact/create';
import ContactDetail from '@/pages/contact/show';
import ContactUpdate from '@/pages/contact/update';
import { DashboardPage } from '@/pages/dashboard';
import ImportProgressList from '@/pages/import-progress/list';
import Invoice from '@/pages/invoice';
import InvoiceDetail from '@/pages/invoice/show';
import { OrderCreatePage } from '@/pages/order/create';
import { OrderListPage } from '@/pages/order/list';
import { OrderDetailPage } from '@/pages/order/show';
import Profile from '@/pages/profile';
import UserManagement from '@/pages/user-management';

const AppRoutes: React.FC = () => (
  <Routes>
    <Route path="/auth" element={<Authenticated key="auth" fallback={<Outlet />}><NavigateToResource /></Authenticated>}>
      <Route path="login" element={<Login />} />
      <Route path="account-activation/:token_code" element={<AccountActivation />} />
      <Route path="reset-password/:token_code" element={<ResetPassword />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="*" element={<ErrorComponent />} />
    </Route>

    <Route
      element={
        <Authenticated key="main-layout" fallback={<CatchAllNavigate to="/auth/login" />}>
          <CanAccess fallback={<CatchAllNavigate to="/403" />}>
            <MainLayout />
          </CanAccess>
        </Authenticated>
      }
    >
      <Route
        index
        element={<DashboardPage />}
      />
      <Route path="profile" element={<Profile />} />
      <Route path="user-management" element={<UserManagement />} />

      <Route path="branches">
        <Route index element={<Branch />} />
        <Route path="create" element={<BranchCreate />} />
        <Route path="edit/:id" element={<BranchUpdate />} />
        <Route path="show/:id" element={<BranchDetail />} />
      </Route>

      <Route path="contacts">
        <Route index element={<Contact />} />
        <Route path="create" element={<ContactCreate />} />
        <Route path="edit/:id" element={<ContactUpdate />} />
        <Route path="show/:id" element={<ContactDetail />} />
      </Route>

      <Route path="orders">
        <Route index element={<OrderListPage />} />
        <Route path="create" element={<OrderCreatePage />} />
        <Route path="show/:id" element={<OrderDetailPage />} />
      </Route>

      <Route path="invoices">
        <Route index element={<Invoice />} />
        <Route path="show/:id" element={<InvoiceDetail />} />
      </Route>

      <Route path="check-shipping-price" element={<CheckShippingPrice />} />

      <Route path="/import-progress">
        <Route index element={<ImportProgressList />} />
      </Route>

      <Route path="*" element={<ErrorComponent />} />
    </Route>

    <Route path="*" element={<ErrorComponent />} />
  </Routes>
);

export default AppRoutes;
